<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <redeem-request-table></redeem-request-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import redeemRequestTable from './RedeemRequestTable.vue'

  export default {
    name: 'redeemRequest',
    components: {redeemRequestTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/loyaltypoint/RedeemRequest.vue